
function SdOrderDocsCtrl(TranslationService, MaterialService, StoreService, ToastService, WorkflowService, DocService, $uibModal, $window) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {
        console.log('$onInit sd-order-docs');
        
    };

    ctrl.$onChanges = function (newValues, oldValues) {
        //console.log('SD-ORDER-ITEMS.ONCHANGES');
        if (newValues.order) {
            if (newValues.order.currentValue && newValues.order.currentValue.Details) {
                //ctrl.prepareForEdit(newValues.order.currentValue);
            }
        }
    };

    //JRM: PEGAR DO CADASTRO DE DOCUMENTOS
    ctrl.getFileType = function (file) {
        var name = file.Name;
        //console.log('getFileType ' + name);
        if (name) {
            switch (name.substr(0, 2)) {
                case '01':
                    return 'Order Confirmation';
                case '02':
                    return 'Invoice';
                case '03':
                    return 'Packing List';
                case '04':
                    return 'ISF';
                case '05':
                    return 'Lacey Act';
                case '06':
                    return 'Shipment Advice';
                case '07':
                    return 'Certificado HT';
                case '17':
                    return 'Softwood Lumber Declaration';
                case '50':
                    return 'Bill of Lading';
                default:
                    return '_';
            }
        }
    };
    

    ctrl.showPdf = function (order, doc) {
        var modalInstance = $uibModal.open({
            templateUrl: 'SPA/orders/showPdfModal.html',
            controller: 'ShowPdfCtrl',
            size: 'xl',
            resolve: {
                order: function () {
                    return order;
                },
                doc: function () {
                    return doc;
                }
            }
        });
        modalInstance.result.then(function (selectedItem) { });
    };


    ctrl.getFile = function (file) {
        //console.log('getFile');
        ctrl.order.error = null;
        var toastID = ToastService.createToast('Baixando arquivo...', file.Name, 0, 'wait');
        ctrl.downloading = true;
        DocService.getFtpFile(file.AbsolutePath).then(function (result) {
            ctrl.downloading = false;
            ToastService.removeToast(toastID);

            var blob = new Blob([result.data], { type: "application/pdf" });
            var objectUrl = URL.createObjectURL(blob);
            var fileName = file.Name;
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(blob, fileName);
            }
            var pdf = document.createElement('a');
            pdf.href = objectUrl;

            /*
            //AQUI FAZ DOWNLOAD
            pdf.download = fileName;
            pdf.click();
            window.URL.revokeObjectURL(objectUrl);
            */
            //console.log(objectUrl);
            $window.open(objectUrl, '_blank');
        },
            function (err) {
                ctrl.downloading = false;
                //console.log('Error');
                //console.log(err);
                ctrl.order.error = err;
                var errMsg = '';
                if (err.data && err.data.ExceptionMessage) {
                    errMsg = err.data.ExceptionMessage;
                }
                ToastService.updateToast(toastID, 'Erro!', errMsg, 2000, 'error');
            });
    };


}

SdOrderDocsCtrl.$inject = ['TranslationService', 'MaterialService', 'StoreService', 'ToastService', 'WorkflowService', 'DocService', '$uibModal', '$window'];

seedWebApp.component('sdOrderDocs', {
    controller: SdOrderDocsCtrl,
    bindings: {
        loading: '<',
        order: '<',
        disabled: '<',
    },
    templateUrl: '/SPA/Orders/sd-order-docs.html' + seedWebApp.buildVersion
});
